module.exports = __webpack_public_path__ + "media/images/flags/64/Morocco-d75979f5d7b7d4deedfe29f8ce483e46.png";